import { api } from "@/services/api"
import { queryClient } from "@/queryClient"
export const passwordLogIn = async (params: {
  email: string
  password: string
}) => {
  await api.post("/beepaidgo/session/login/", {
    body: params,
  })
  queryClient.invalidateQueries({
    queryKey: [CURRENT_USER_QUERY_KEY],
  })
  queryClient.invalidateQueries({
    queryKey: [CURRENT_TENANT_QUERY_KEY],
  })
}
